var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 6V5C13 2.79086 11.2091 1 9 1V1C6.79086 1 5 2.79086 5 5V6",
    stroke: "#EE2D2F",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 5C14.8284 5 16.2424 5.00023 17.1211 5.87891C17.9998 6.75759 18 8.17157 18 11V12C18 15.7712 17.9997 17.6566 16.8281 18.8281C15.6566 19.9997 13.7712 20 10 20H8C4.22876 20 2.34345 19.9997 1.17188 18.8281C0.000302168 17.6566 0 15.7712 0 12V11C0 8.17157 0.000226594 6.75759 0.878906 5.87891C1.75759 5.00023 3.17157 5 6 5H12ZM9 9C7.34315 9 6 10.3431 6 12C6 13.3057 6.83548 14.413 8 14.8252V17H10V14.8252C11.1645 14.413 12 13.3057 12 12C12 10.3431 10.6569 9 9 9ZM9 11C9.55229 11 10 11.4477 10 12C10 12.5523 9.55229 13 9 13C8.44771 13 8 12.5523 8 12C8 11.4477 8.44771 11 9 11Z",
    fill: "#EE2D2F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockIcon);
export default __webpack_public_path__ + "static/media/lock_icon.0edc7bc5.svg";
export { ForwardRef as ReactComponent };